import { FlexCol } from '@/components/ui/flex';
import type { FC } from 'react';
import { SharedKnowledgePage as SharedKnowledgeContent } from '../../components/sharedKnowledgePage';

export const AdminSharedKnowledgePage: FC = () => {
  return (
    <FlexCol gap="6" w="full" h="full" p="6" className="max-w-[1600px]">
      <SharedKnowledgeContent />
    </FlexCol>
  );
};
